import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F7F5F0] flex items-center justify-center p-8">
      <div className="w-full max-w-md">
        <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#6C7565]">Account recovery</span>
        <h2 className="font-serif text-4xl lg:text-5xl mt-2 mb-8 tracking-tight">Forgot password.</h2>

        {sent ? (
          <div className="border-2 border-[#2E6F40] bg-white p-8 shadow-[6px_6px_0px_#2E6F40]" data-testid="forgot-sent-notice">
            <p className="font-serif text-xl leading-relaxed">
              If <strong>{email}</strong> is on our books, a reset link is on its way. It's valid for one hour.
            </p>
            <p className="font-mono text-[10px] uppercase tracking-widest text-[#6C7565] mt-4">
              Check your inbox (and spam folder).
            </p>
          </div>
        ) : (
          <form onSubmit={submit} data-testid="forgot-password-form">
            <label className="block mb-8">
              <span className="font-mono text-[10px] tracking-widest uppercase text-[#6C7565] block mb-2">Email</span>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="forgot-email-input"
                className="w-full bg-transparent border-0 border-b border-[#1A1F16] py-2 text-lg focus:outline-none focus:border-[#A67C00]"
                placeholder="you@home.in"
              />
            </label>
            <button
              type="submit"
              disabled={busy}
              data-testid="forgot-submit-btn"
              className="w-full bg-[#1A1F16] text-[#F7F5F0] py-4 uppercase tracking-[0.25em] text-xs hover:bg-[#2C3628] disabled:opacity-50 transition-colors"
            >
              {busy ? "Sending…" : "Send reset link"}
            </button>
          </form>
        )}

        <p className="mt-8 text-sm text-[#6C7565]">
          Remembered it?{" "}
          <Link to="/login" className="text-[#1A1F16] underline underline-offset-4 hover:text-[#A67C00]" data-testid="forgot-to-login-link">
            Back to sign in →
          </Link>
        </p>
      </div>
    </div>
  );
}
